import { render, staticRenderFns } from "./SolutionCard.vue?vue&type=template&id=c4c53a4a&scoped=true"
import script from "./SolutionCard.vue?vue&type=script&lang=js"
export * from "./SolutionCard.vue?vue&type=script&lang=js"
import style0 from "./SolutionCard.vue?vue&type=style&index=0&id=c4c53a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c53a4a",
  null
  
)

export default component.exports